import { Statement } from 'interfaces';
import { providerRefs, siteRefs } from '../../factories/seeds/entities';
import { mockProviders } from './providerMock';
import { mockSites } from './siteMock';

const providerByID = new Map(
  mockProviders.map((provider) => [provider.id, provider])
);
const siteByID = new Map(mockSites.map((site) => [site.id, site]));

const statementProvider = providerByID.get(providerRefs.adamDonen.id) || null;
const statementSite = siteByID.get(siteRefs.qdocVirtualHealthcare.id) || null;

export const mockStatements: Statement[] = [
  {
    id: 'f5a6d4db-9ef8-499b-a2b2-d332cac54829',
    providerID: statementProvider?.id ?? '',
    startDate: '2025-03-16T05:00:00.000Z',
    endDate: '2025-04-01T04:59:59.999Z',
    reportPath: 'Income/income-report-2025-03-24T19:47:56.482+00:00.pdf',
    provider: statementProvider,
    totalAmount: 880.06,
    statementPath:
      `Statements/${statementProvider?.id ?? ''}/${statementSite?.id ?? ''}/2025-03-16T00:00:00.000+00:00-2025-03-24T23:59:59.999+00:00.json`,
  },
  {
    id: '9e295728-e435-4bd2-b2df-3ccc86c2ffb7',
    providerID: statementProvider?.id ?? '',
    startDate: '2025-03-01T06:00:00.000Z',
    endDate: '2025-03-16T04:59:59.999Z',
    provider: statementProvider,
    reportPath: null,
    totalAmount: 1009.87,
    statementPath:
      `Statements/${statementProvider?.id ?? ''}/${statementSite?.id ?? ''}/2025-03-01T00:00:00.000+00:00-2025-03-15T23:59:59.999+00:00.json`,
  },
];
